import React, { useMemo, useCallback, useEffect, useState } from "react";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import { isLiveStatus, isFinishedStatus, isStartListStatus } from "helpers/status";
import Status from "components/presentation/Status";
import { useViewport } from 'components/general/useViewPort'
import { ridingColumns } from "../riding/columns";
import TableExpanded from "../teams/TableExpanded";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import NotAvailable from "components/common/NotAvailable";
import { isTeam } from "../helper/MpnHelpers";

const getConfiguration = ({ rsc, breakPoint, resultStatus, scheduleStatus, configNode, currentIntermediate, heat }) => {
    const isStartList = isStartListStatus(resultStatus);
    const isLive = isLiveStatus(resultStatus);
    const isFinished = isFinishedStatus(resultStatus);
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    let configuration = {
        sortBy: [],
        columns: [],
        hiddenColumns: [],
        caption: null
    };

    configuration.caption = <CaptionTable
        //leftCol=''
        //centerCol=''
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartList
        ? [{ id: 'StartOrder', desc: false }]
        : [{ id: 'Rank', desc: false }]


    configuration.columns = ridingColumns(isFinished);

    const startListHidden = isStartList ? ['Expander', 'Rank'] : []

    const mobileLiveHidden = isMobile && isLive ? ['StartOrder'] : []

    const finishedHidden = isFinished ? ['StartOrder', 'StartTime'] : []

    const mobileHidden = isMobile ? ['Name', 'Horse', 'StartTime' ] : ['AthleteHorse'];


    configuration.hiddenColumns = [...mobileHidden, ...startListHidden, ...mobileLiveHidden, ...finishedHidden];

    if(!isTeam(rsc)) {
        configuration.hiddenColumns.push('Expander');
        configuration.hiddenColumns.push('HorseTeam');
    } else {
        configuration.hiddenColumns.push('Horse');
    }

    return configuration;
}


const MpnRiding = ({ data }) => {

    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;

    const rsc = data?.results?.eventUnitCode;

    const configEvent = useMemo(() => getConfiguration({
        rsc: rsc,
        breakPoint: breakPoint,
        resultStatus: resultStatus,
        scheduleStatus: scheduleStatus,
    }), [resultStatus, breakPoint]);

    const renderRowSubComponent = useCallback(({ row }) => {
        const intermediates = [];
        let componentExpanded = <TableExpanded row={row?.original} intermediates={intermediates} />
        return (
            <LoaderSubComponent component={componentExpanded} />
        )
        // eslint-disable-next-line
    }, [resultStatus]);

    if (!data?.results?.items) return <NotAvailable />;

 
    const getCurrentIndicator = (row) => {
        const currentId = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'CURRENT')?.ei_value;
        const isCurrent = row.original.participant.code === currentId;
        let out = { className: isCurrent ? 'currentIndicator' : '' }
        return out
    }


    return (
        <>
            <MirsTable
                sortable={!isMobile}
                data={data.results.items}
                columns={configEvent.columns}
                keyRow='participant-code'
                caption={configEvent.caption}
                //Columns to hidde 
                hiddenColumns={configEvent.hiddenColumns}
                //When show tble is sorted by 
                initialSortBy={configEvent.sortBy}
                id={`mirs-table-result-${rsc}`}
                renderRowSubComponent={renderRowSubComponent}
                getRowProps={row => { return getCurrentIndicator(row) }}
            //hasRelatedTimeline={true}
            />
        </>
    );
};

export default MpnRiding;
